import { RequestQueryService } from "../../../services/request/RequestQueryService";
import { RequestModel } from "../../models/Request";
import { IQueryRequestRepository } from "../../ports/request/IQueryRequestRepository";
import Query from "../Query";

class RequestQuery
  extends Query<RequestModel>
  implements IQueryRequestRepository
{
  constructor(public queryService: RequestQueryService) {
    super(queryService);
  }
}

export default RequestQuery;
